import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Grid({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M7.75 9.75H5C3.895 9.75 3 8.85 3 7.75V5C3 3.895 3.895 3 5 3H7.75C8.85 3 9.75 3.895 9.75 5V7.75C9.75 8.85 8.85 9.75 7.75 9.75Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M19 9.75H16.25C15.14 9.75 14.25 8.85 14.25 7.75V5C14.25 3.895 15.14 3 16.25 3H19C20.1 3 21 3.895 21 5V7.75C21 8.85 20.1 9.75 19 9.75Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M7.75 21H5C3.895 21 3 20.1 3 19V16.25C3 15.14 3.895 14.25 5 14.25H7.75C8.85 14.25 9.75 15.14 9.75 16.25V19C9.75 20.1 8.85 21 7.75 21Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M19 21H16.25C15.14 21 14.25 20.1 14.25 19V16.25C14.25 15.14 15.14 14.25 16.25 14.25H19C20.1 14.25 21 15.14 21 16.25V19C21 20.1 20.1 21 19 21Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Grid;